import { render, staticRenderFns } from "./FormTitle.vue?vue&type=template&id=1cb47e29&scoped=true&"
import script from "./FormTitle.vue?vue&type=script&lang=js&"
export * from "./FormTitle.vue?vue&type=script&lang=js&"
import style0 from "./FormTitle.vue?vue&type=style&index=0&id=1cb47e29&scoped=true&lang=css&"
import style1 from "./FormTitle.vue?vue&type=style&index=1&id=1cb47e29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb47e29",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VIcon})
